import { FileText, Image, Film, Music } from "@/components/Icons";

function getTypeIcon(types) {
  if (!types || types.length === 0) return <FileText size={12} />;
  const t = types[0].toLowerCase();
  if (t.includes("photograph") || t.includes("graphic") || t.includes("image")) return <Image size={12} />;
  if (t.includes("motion") || t.includes("video") || t.includes("film")) return <Film size={12} />;
  if (t.includes("sound") || t.includes("audio") || t.includes("recording")) return <Music size={12} />;
  return <FileText size={12} />;
}

export default function RecordCard({ record, index, onClick, onSave, onUnsave, isSaved }) {
  const handleSaveClick = (e) => {
    e.stopPropagation();
    if (isSaved) {
      onUnsave?.(record.naId || record.naid);
    } else {
      onSave?.(record);
    }
  };

  return (
    <div
      className={`record-card p-5 animate-fade-in stagger-${(index % 8) + 1}`}
      onClick={() => onClick?.(record)}
      data-testid={`record-card-${record.naId || record.naid}`}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && onClick?.(record)}
    >
      <div className="flex items-start justify-between gap-3 mb-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-2 flex-wrap">
            {record.types && record.types.length > 0 && (
              <span className="type-badge" data-testid={`record-type-badge-${record.naId || record.naid}`}>
                {getTypeIcon(record.types)}
                {record.types[0]}
              </span>
            )}
            {record.recordType && (
              <span className="type-badge">
                {record.recordType}
              </span>
            )}
            {record.hasOnlineContent && (
              <span className="type-badge" style={{ borderColor: "#B85C38", color: "#B85C38" }}>
                Online
              </span>
            )}
          </div>
          <h3
            className="font-serif text-lg font-medium text-[#1A1A1A] leading-snug"
            data-testid={`record-title-${record.naId || record.naid}`}
          >
            {record.title}
          </h3>
        </div>
        <button
          className="btn-ghost p-2 flex-shrink-0"
          onClick={handleSaveClick}
          data-testid={`save-record-btn-${record.naId || record.naid}`}
          title={isSaved ? "Remove bookmark" : "Bookmark this record"}
        >
          {isSaved ? (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="#B85C38" stroke="#B85C38" strokeWidth="2">
              <path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z" />
            </svg>
          ) : (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z" />
            </svg>
          )}
        </button>
      </div>

      {record.description && (
        <p className="text-sm text-[#4A5568] leading-relaxed mb-3 line-clamp-2">
          {record.description}
        </p>
      )}

      <div className="flex items-center gap-4 flex-wrap">
        {record.dateRange && (
          <span className="font-mono text-xs text-[#718096] uppercase tracking-wider" data-testid={`record-date-${record.naId || record.naid}`}>
            {record.dateRange}
          </span>
        )}
        <span className="font-mono text-xs text-[#718096] tracking-wider">
          NAID: {record.naId || record.naid}
        </span>
        {record.contributingArchive && (
          <span className="font-mono text-xs text-[#718096] tracking-wider hidden sm:inline">
            {record.contributingArchive}
          </span>
        )}
      </div>

      {record.hierarchy && Object.keys(record.hierarchy).length > 0 && (
        <div className="mt-3 pt-3 border-t border-[#E5E2D9]">
          {Object.entries(record.hierarchy).map(([key, value]) =>
            value ? (
              <div key={key} className="flex items-baseline gap-2 text-xs mb-1">
                <span className="font-mono uppercase tracking-widest text-[#718096] w-24 flex-shrink-0">
                  {key.replace(/([A-Z])/g, " $1").trim()}
                </span>
                <span className="text-[#4A5568]">{value}</span>
              </div>
            ) : null
          )}
        </div>
      )}
    </div>
  );
}
